import { Logomark } from "@platform/ui/components";
import { copy, heading } from "@platform/ui/styles";
import { Slot } from "@radix-ui/react-slot";
import * as React from "react";
import { twMerge } from "tailwind-merge";

export const ErrorDisplayRoot = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  function ErrorDisplayRoot({ children, className, ...rest }, ref) {
    return (
      <div ref={ref} {...rest} className={twMerge("flex w-full flex-col gap-12", className)}>
        {children}
      </div>
    );
  },
);

export const ErrorDisplayLogo = React.forwardRef<SVGSVGElement, React.ComponentPropsWithoutRef<"svg">>(
  function ErrorDisplayLogo({ className, ...rest }, ref) {
    return <Logomark ref={ref} {...rest} className={twMerge("mx-auto h-[56px] md:h-[72px]", className)} />;
  },
);

export const ErrorDisplayContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  function ErrorDisplayContent({ children, className, ...rest }, ref) {
    return (
      <div ref={ref} {...rest} className={twMerge("flex flex-col gap-8", className)}>
        {children}
      </div>
    );
  },
);

export const ErrorDisplayLockup = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  function ErrorDisplayLockup({ children, className, ...rest }, ref) {
    return (
      <div ref={ref} {...rest} className={twMerge("flex flex-col gap-2", className)}>
        {children}
      </div>
    );
  },
);

interface ErrorDisplayHeadlineProps extends React.HTMLAttributes<HTMLHeadingElement> {
  asChild?: boolean;
}

export const ErrorDisplayHeadline = React.forwardRef<HTMLHeadingElement, ErrorDisplayHeadlineProps>(
  function ErrorDisplayHeadline({ children, className, asChild, ...rest }, ref) {
    const Comp = asChild ? Slot : "h1";

    return (
      <Comp
        ref={ref}
        {...rest}
        className={twMerge(heading({ variant: "24", align: "center", className: "md:text-4xl" }), className)}
      >
        {children}
      </Comp>
    );
  },
);

export const ErrorDisplayMessage = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  function ErrorDisplayMessage({ children, className, ...rest }, ref) {
    return (
      <div
        ref={ref}
        {...rest}
        className={twMerge(
          copy({
            variant: "16",
            align: "center",
            color: "secondary",
            className: "mx-auto max-w-[50ch] text-balance md:text-lg",
          }),
          className,
        )}
      >
        {children}
      </div>
    );
  },
);

export const ErrorDisplayActions = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  function ErrorDisplayActions({ children, className, ...rest }, ref) {
    return (
      <div ref={ref} {...rest} className={twMerge("flex justify-center gap-2", className)}>
        {children}
      </div>
    );
  },
);
